import React from 'react'
import ActionsGetMoviesList from './ActionsGetMoviesList'
import ReadMore from '../Readmorewords'
import dateFormovieListCreatedTime from './formatedDate'
import AwsConfig from '../../../Config/AwsConfig'

function TableChildMovieList(props) {
  const {
    // tableHeders,
    isLoading,
    handleDeleteClick,
    loadMoreData,
    serviceData,
    loadMore,
    checkBoxArr,
    setServiceData,
    checkboxfunction,
    status,
    ApproveOptionBoolean,
    EDitOptionPermission,
    DeleteOptionPermission,
  } = props
  console.log(serviceData, 'dataaaa')
  const cssBorders = {
    main: {
      borderBottom: '1px solid white',
      borderLeft: '1px solid white',
      borderRight: '1px solid white',
    },
  }
  const poster = url => {
    if (url) {
      const cdnurl = AwsConfig.movieCdnUrl
      if (url && !url.includes(cdnurl)) {
        url = cdnurl + url
        return url
      }

      return url
    }
  }

  const headers = serviceData.length === 0 ? [] : Object.keys(serviceData[0])
  return (
    <div className='App' style={{ fontFamily: 'sans-serif' }}>
      {serviceData.length === 0 ? (
        'No Data Found'
      ) : (
        <table style={{ border: '1px solid lightgray' }} className='table table-striped'>
          <tr className='tableheader'>
            <th style={cssBorders.main}>S.No</th>
            <th style={cssBorders.main}>Check Box</th>
            <th style={cssBorders.main}>Actions</th>
            {headers.map((item, index) =>
              item === 'PK' || item === 'SK' || item === '__typename' ? (
                ''
              ) : (
                <th key={index} style={cssBorders.main}>
                  {item}{' '}
                </th>
              ),
            )}{' '}
          </tr>

          {serviceData &&
            serviceData.map((val, index) => (
              <tr className='column' key={index}>
                <td className='tablerow '>{index + 1}</td>
                <td className='tablerow '>
                  <input
                    checked={Boolean(checkBoxArr.some(x => x.SK === val.SK))}
                    name={val.PK}
                    value={val.SK}
                    type='checkbox'
                    onChange={checkboxfunction}
                  />
                </td>
                <td className='tablerow '>
                  {/* {console.log(status, 'status in tablechild')} */}
                  <ActionsGetMoviesList
                    index={index}
                    item={val}
                    serviceData={serviceData}
                    setServiceData={setServiceData}
                    handleDeleteClick={handleDeleteClick}
                    status={status}
                    ApproveOptionBoolean={ApproveOptionBoolean}
                    EDitOptionPermission={EDitOptionPermission}
                    DeleteOptionPermission={DeleteOptionPermission}
                  />
                </td>
                <td className='tablerow '>{val.createdByHandle}</td>
                <td className='tablerow '>{val.createdByID}</td>
                <td className='tablerow '>
                  {dateFormovieListCreatedTime(val.movieListCreatedTime)}
                </td>
                <td className='tablerow '>{dateFormovieListCreatedTime(val.updatedTime)}</td>
                <td className='tablerow '>{val.movieListID}</td>
                <td className='tablerow '>{val.title_En}</td>
                <td className='tablerow '>{val.title_Te}</td>
                <td className='tablerow '>
                  <ReadMore>{val.description_En}</ReadMore>
                </td>
                <td className='tablerow '>
                  <ReadMore>{val.description_Te}</ReadMore>
                </td>
                <td className='tablerow '>
                  <img width={100} height={100} src={poster(val.movieListImage)} />
                  {/* {} */}
                </td>
                <td className='tablerow '>{val.movieListType}</td>
                <td className='tablerow '>{val.movieListCategory}</td>
                <td className='tablerow '>{val.movieListTypeAndCategory}</td>
              </tr>
            ))}
        </table>
      )}
      {loadMore ? (
        <div className='btn btn-primary mt-2' onClick={loadMoreData}>
          Load More ...
        </div>
      ) : (
        ''
      )}
      {isLoading ? (
        <div className='loading-overlay'>
          <span className='fas fa-spinner fa-3x fa-spin'></span>
        </div>
      ) : (
        ''
      )}
    </div>
  )
}

export default TableChildMovieList
